<template>
  <component :is="currentComponent" v-if="currentComponent" />
</template>

<script>
// Async load the Vue 3 APIs we need from the VUE ESM
import { defineAsyncComponent, defineComponent } from 'vue/dist/vue.esm-bundler'

const COMPONENT_MAP = {
  blogposts: defineAsyncComponent(
    () => import(/* webpackChunkName: "blogposts" */ './modules/BlogPosts.vue'),
  ),
}

export default defineComponent({
  components: COMPONENT_MAP,
  data: () => ({
    currentComponent: null,
  }),
  created() {
    const container = document.getElementById('componentContainer')
    const componentName = container?.dataset?.component?.toLowerCase()
    this.currentComponent = componentName && COMPONENT_MAP[componentName] ? componentName : null
  },
})
</script>
